import React, { useState, useEffect } from 'react';
//import Tabs from 'react-bootstrap/Tabs';//'@restart/ui/Tabs';
import { Card, CardActionArea, CardContent, CardMedia, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import Grow from '@mui/material/Grow';

import './Portfolio.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CloseIcon from '@mui/icons-material/Close';
import resumeData from '../../__utils/resumeData';
import ImageGallery from '../../components/ImageGallery/ImageGallery';

import { ProjectType } from '../../types/interface';

function Portfolio() {
    const [tabValue, setTabValue] = useState('mvp');
      // Změna: Dva stavy pro dialog
  const [openProjectDialog, setOpenProjectDialog] = useState<boolean>(false);
  const [selectedProject, setSelectedProject] = useState<ProjectType | null>(null);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const handleCardClick = (project: ProjectType) => {
    setSelectedProject(project);
    setOpenProjectDialog(true);
  };

  const handleDialogClose = () => {
    setOpenProjectDialog(false);
    setSelectedProject(null); // Volitelné: vyčistí vybraný projekt po zavření
  };

    return (
        <div className='portfolio_main_content'>
      <Grid container className="section pb_45">
        <Grid item className="section_title mb_30">
          <span></span>
          <h6 className='section_title_text'>Portfolio</h6>
        </Grid>

        {/* TABS */}
        <Grid item xs={12}>
          <Tabs value={tabValue} indicatorColor="white" className="customTabs" onChange={handleTabChange}>
            <Tab
              label="Highlights"
              value="mvp"
              className={tabValue === "mvp" ? "customTabs_item active" : "customTabs_item"}
            />
            {/* Generování tabů dynamicky z tagů projektů */}
            {[...new Set(resumeData.projects.map((item) => item.tag))].map((tag) => (
              tag && ( // Zabraň vykreslení, pokud je tag undefined
                <Tab
                  key={tag} // Klíč pro React seznamy
                  label={tag}
                  value={tag}
                  className={tabValue === tag ? "customTabs_item active" : "customTabs_item"}
                />
              )
            ))}
          </Tabs>
        </Grid>

        {/* Projekty */}
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {resumeData.projects
              .filter(project => {
                // Logika filtrování projektů
                if (tabValue === 'mvp') {
                  return project.tagmvp === 'MVP'; // Filtruj projekty s tagmvp 'MVP'
                } else {
                  return project.tag === tabValue; // Filtruj podle vybraného tagu
                }
              })
              .map((project) => (
                <Grid item xs={12} sm={6} md={4} key={project.title}> {/* Přidej key prop */}
                  <Grow in timeout={1000}>
                    <Card className='customCard' onClick={() => handleCardClick(project)}>
                      <CardActionArea>
                        {/* Zkontroluj, zda project.images existuje a má alespoň jeden prvek */}
                        {project.images && project.images.length > 0 && (
                          <CardMedia
                            className='customCard_image'
                            image={project.images[0]}
                            title={project.title}
                          />
                        )}
                        <CardContent>
                          <Typography variant={'body2'} className='customCard_title'>{project.title}</Typography>
                          <Typography variant="caption" className='customCard_caption'>{project.caption}</Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grow>
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>

      {/* Dialog pro detail projektu */}
      {selectedProject && ( // Renderuj dialog pouze, když je selectedProject nastaven
        <Dialog open={openProjectDialog} onClose={handleDialogClose} className='projectDialog' maxWidth="md">
          <DialogTitle>
            {selectedProject.title}
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ height: "80vh" }}>
            {/* Zajištění, že se ul vykreslí, jen když je alespoň jeden tag */}
            {(selectedProject.tag || selectedProject.tag2 || selectedProject.tag3 || selectedProject.tag4) && (
              <ul className='projectDialog_tag_item'>
                {selectedProject.tag && <li><Typography variant="caption" className='projectDialog_tag'>{selectedProject.tag}</Typography></li>}
                {selectedProject.tag2 && <li><Typography variant="caption" className='projectDialog_tag'>{selectedProject.tag2}</Typography></li>}
                {selectedProject.tag3 && <li><Typography variant="caption" className='projectDialog_tag'>{selectedProject.tag3}</Typography></li>}
                {selectedProject.tag4 && <li><Typography variant="caption" className='projectDialog_tag'>{selectedProject.tag4}</Typography></li>}
              </ul>
            )}
            {selectedProject.images && selectedProject.images.length > 0 && (<ImageGallery images={selectedProject.images} />)}
            <Typography className='projectDialog_description'>{selectedProject.description}</Typography>
          </DialogContent>
          <DialogActions className='projectDialog_actions'>
            {selectedProject.links?.map((link, i) => (
              // Opraven překlep 'taget' na 'target' a přidán rel="noopener noreferrer"
              <a href={link.link} target='_blank' rel="noopener noreferrer" className='projectDialog_icon' key={i}>{link.icon}</a>
            ))}
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

export default Portfolio;